import { render } from "./AIVerbatimsCache.vue?vue&type=template&id=34a40732"
import script from "./AIVerbatimsCache.vue?vue&type=script&lang=js"
export * from "./AIVerbatimsCache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__